import React, { useState } from 'react';
import i18n from 'i18n/config';

import List from 'modules/documents/components/List';
import documentSections from 'constants/documentSections';

const currentSection = 'ASSIGNMENTS';

const Assignments = ({ documents, isLoadingData, searchTerm }) => {
  const [section] = useState(
    documentSections(i18n).find((s) => s.tag === currentSection)
  );
  return (
    <>
      <List
        section={section}
        documents={documents}
        isLoadingData={isLoadingData}
        searchTerm={searchTerm}
      />
    </>
  );
};

export default Assignments;
